// extracted by mini-css-extract-plugin
export default {"result":"Result_result__0HzXJ","text":"Result_text__7Axj5","red":"Result_red__BA5rL"};